export const BrandAndDevicePartnerIds = Object.freeze({
  GARMIN: 'garmin',
  ZWIFT: 'zwift',
  WAHOO: 'wahoo',
  FITBIT: 'fitbit',
  SAMSUNG: 'samsung',
  WHOOP: 'whoop',
  OURA: 'oura',
  ROUVY: 'rouvy'
});

export type BrandAndDevicePartnerIdsType =
  (typeof BrandAndDevicePartnerIds)[keyof typeof BrandAndDevicePartnerIds];
